import React from 'react';
import './Pages.css';

const Framework = () => {
  const handleDownload = (filename) => {
    const link = document.createElement('a');
    link.href = `/assest/img/${filename}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const documents = [
    {
      id: 1,
      title: "Innovation Framework FN",
      category: "Strategic Framework",
      description: "Comprehensive framework for innovation ecosystem development and technological advancement.",
      filename: "INNOVATION FRAMEWORK FN.pdf",
      icon: "fas fa-lightbulb"
    },
    {
      id: 2,
      title: "National Guidelines for TICs",
      category: "National Guidelines", 
      description: "Step-by-step instructions for establishing and developing Technology and Innovation Centers.",
      filename: "NATIONAL GUIDELINES FOR ESTABLISHMENT AND DEVELOPMENT OF TICs .pdf",
      icon: "fas fa-building"
    },
    {
      id: 3,
      title: "Tracer Study",
      category: "Research Report",
      description: "Comprehensive study tracking the impact and outcomes of our programs and initiatives.",
      filename: "Tracer Study.pdf",
      icon: "fas fa-chart-line"
    },
    {
      id: 4,
      title: "Company Profile",
      category: "Company Report",
      description: "BUNI HUB 2024 company profile showcasing our mission, vision, and achievements.",
      filename: "BUNI HUB 2024_Company Profile.pdf",
      icon: "fas fa-building"
    },
    {
      id: 5,
      title: "Innovation Ecosystem Report",
      category: "Ecosystem Report",
      description: "Detailed analysis of the innovation ecosystem and its development trends for 2025.",
      filename: "INNOVATION ECOSYSTEM REPORT_2025_v8.pdf",
      icon: "fas fa-network-wired"
    }
  ];

  return (
    <div className="framework-page">
      {/* Compact Hero Section */}
      <section className="framework-hero-compact">
        <div className="framework-hero-container">
          <h1 className="framework-hero-title">National Innovation Framework</h1>
          <p className="framework-hero-subtitle">National Guideline for establishment And Development of Technology and Innovation Centers</p>
        </div>
      </section>

      {/* Compact Documents Grid */}
      <section className="framework-content-compact">
        <div className="framework-container">
          <div className="documents-grid-compact">
            {documents.map((doc) => (
              <div key={doc.id} className="document-card-compact">
                <div className="document-header-compact">
                  <div className="document-icon-compact">
                    <i className={doc.icon}></i>
                  </div>
                  <div className="document-info-compact">
                    <div className="document-category-compact">{doc.category}</div>
                    <h3 className="document-title-compact">{doc.title}</h3>
                    <p className="document-description-compact">{doc.description}</p>
                  </div>
                </div>
                <div className="document-actions-compact">
                  <button 
                    className="download-button-compact"
                    onClick={() => handleDownload(doc.filename)}
                  >
                    <i className="fas fa-download"></i>
                    Download PDF
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Framework;
